// extracted by mini-css-extract-plugin
export default {"tabs":"W49XV+9nc-","indicator":"_6XeaaDNebc","error":"KiuuZCNsOx"};
    if(module.hot) {
      // 1648554181684
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  